import type { ParametrosIntegracaoModel } from "../models/parametrosIntegracaoModel"

export enum ParametrosIntegracaoActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    RESETAR = "RESETAR",
}

export type ParametrosIntegracaoActionModel =
    | { type: ParametrosIntegracaoActionsTypes.CARREGAR; payload: ParametrosIntegracaoModel }
    | {
          type: ParametrosIntegracaoActionsTypes.ATUALIZAR_CAMPO
          payload: { campo: keyof ParametrosIntegracaoModel; valor: string | number | boolean | null }
      }
    | { type: ParametrosIntegracaoActionsTypes.RESETAR }
